
import React from 'react';

const GraphPurpleUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='65'
			height='65'
			fill='none'
			viewBox='0 0 65 65'
		>
			<g fill='#B4C9FE' clipPath='url(#clip0)'>
				<path d='M55.92 6.5h-12v4h7.18L33.92 27.68l-6.6-6.6c-.78-.78-2.04-.78-2.82 0l-16 16 2.82 2.82.58-.58V50.5c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V27.32l2-2V50.5c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V29.32l2-2V50.5c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V15.32l2-2v7.18h4v-12c.02-1.1-.88-2-1.98-2zm-36 42h-4V35.32l4-4V48.5zm14 0h-4V29.32l2.58 2.6c.4.4.9.58 1.42.58v16zm14 0h-4V23.32l4-4V48.5zM49.92 60.5h-36v4h36v-4z'></path>
			</g>
			<defs>
				<clipPath id='clip0'>
					<path
						fill='#fff'
						d='M0 0H64V64H0z'
						transform='translate(.5 .5)'
					></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default GraphPurpleUnderline;
